import React from 'react';
import {connect} from 'react-redux';
import { Field, change } from 'redux-form'
import {Card, CardHeader, CardBody, CardFooter, Form, Alert, Button, Row, Col, ButtonGroup} from 'reactstrap';
import ApiConfig from '../../constants/ApiConfig';
import {FieldTxt, FieldSelect} from '../Form/wh-field';
import FieldCkEditor from '../Form/wh-ckeditor';
import * as mediaService from '../../services/media';
import * as sessionService from '../../services/session';
import PopupCollection from './popup/PopupEditCollection'
import Loading from '../Loading';


const titleTemplateOptions = [
    {value : 'test', name : 'test'}
];

const textTemplateOptions = [
    {value : 'test', name : 'test'}
];

const textImgTemplateOptions = [
    {value : 'test', name : 'test'}
];

const titleCollectionTemplateOptions = [
  {value : 'carousel-post', name : 'Carousel Actualité'}
];


class FieldContents extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
           closed : [],
           loaded: false
        };

        this.toggleBox = this.toggleBox.bind(this);
        this.orderUp = this.orderUp.bind(this);
        this.orderDown = this.orderDown.bind(this);
        this.onChildrenChange = this.onChildrenChange.bind(this);
    }

  componentWillMount() {
    this.setState({loaded : true});
  }

   load() {
     this.setState({loaded : true});
   }

    toggleBox(index) {

        let closed = this.state.closed;

        let close = closed.indexOf(index);

        if(close > -1) closed.splice(close, 1);
        else closed.push(index);

        this.setState({closed});

    }

    checkToogleBox(index) {
        return (this.state.closed.indexOf(index) > -1) ? true : false;
    }

    orderUp(fields, index) {

      let newIndex = index - 1;
      if (newIndex < 0) newIndex = 0;
      fields.move(index, newIndex);

      this.setState(
          { loaded : false },
          () => {
            setTimeout(()=>{this.setState({loaded : true})}, 500)
          }
      );

    }

    orderDown(fields, index) {

      let newIndex = index + 1;
      if (newIndex == fields.length) newIndex = index;
      fields.move(index, newIndex);

      this.setState(
          { loaded : false },
          () => {
            setTimeout(()=>{this.setState({loaded : true})}, 500)
          }
      );

    }


    openMediaBox(id) {

        let token = sessionService.getToken()

        let params = {
            access_token    : `${token.access_token}`,
            type            : 'api',
            url             : ApiConfig.finderParams.url,
            endPointMedia   : ApiConfig.finderParams.endPointMedia,
            assetUrl        : ApiConfig.finderParams.assetUrl
        };

        let str = '';
        for (let key in params) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(params[key]);
        }


        const url = `/wh-finder/index.html?${str}#/?id=${id}`;

        window.open(url,"wh media center","location=no, menubar=no, status=no, scrollbars=no, menubar=no, width=800, height=600");

    }


    onImgChange(data, fields, index) {

        let val = data.target.value;

        mediaService.search({filtered : [{id : 'url', value : val}]}).then((data) => {

            data = data['hydra:member'][0];

            let content = fields.get(index);

            content.media = data;
            fields.remove(index);
            fields.insert(index, content);

        });


    }

  onChildrenChange(data, index) {
    let content = this.props.fields.get(index);
    content.childrens = data;
    this.props.fields.remove(index);
    this.props.fields.insert(index, content);
    change(this.props.fields.get(index).childrens, data);
  }

  addBlocOntheTop(fields) {
    fields.unshift({type : 'text'});

    this.setState(
        { loaded : false },
        () => {
          setTimeout(()=>{this.setState({loaded : true})}, 500)
        }
    );
  }

  remove(fields, index) {

    fields.remove(index)
    this.setState(
        { loaded : false },
        () => {
          setTimeout(()=>{this.setState({loaded : true})}, 500)
        }
    );


  }


  render() {

        const { fields,  meta: { touched, error }, defaultBlocOrder } = this.props;

        return (
            <div className="animated fadeIn">

              <div>

                {!defaultBlocOrder &&
                  <Card>
                    <ButtonGroup>
                      <Button size="lg" onClick={() => fields.unshift({type : 'title'})} style={{flex : 1}}><i className={'fa fa-i-cursor'} /></Button>
                      <Button size="lg" onClick={() => this.addBlocOntheTop(fields)}><i className={'fa fa-align-justify'} /></Button>
                      <Button size="lg" onClick={() => fields.unshift({type : 'img'})} style={{flex : 1}}><i className={'fa fa-image'} /></Button>
                      <Button size="lg" onClick={() => fields.unshift({type : 'textImg'})} style={{flex : 1}}><i className={'fa fa-align-justify'} /> + <i className={'fa fa-image'} /></Button>
                      <Button size="lg" onClick={() => fields.unshift({type : 'collection'})} style={{flex : 1}}><i className={'fa fa-th-large'} /></Button>
                    </ButtonGroup>
                  </Card>
                }



                <PopupCollection ref={'popupCollection'} onChildrenChange={this.onChildrenChange} />

                {fields.map((el, index) => {

                return (

                    <div key={index}>
                      {fields.get(index).type == 'title' &&
                      <Card>
                        <CardHeader>
                          <i className="fa fa-i-cursor"/> Bloc titre {index}

                          <div className="card-actions">
                            <a href={`javascript:void(0)`} onClick={() => this.orderUp(fields, index)}><i className={'fa fa-arrow-up'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.orderDown(fields, index)}><i className={'fa fa-arrow-down'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => fields.remove(index)}><i className={'fa fa-trash'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.toggleBox(index)}><i className={this.checkToogleBox(index) ? 'fa fa-angle-up' : 'fa fa-angle-down'} /></a>
                            <a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'} /></a>
                          </div>

                        </CardHeader>

                        <CardBody style={{display : (this.checkToogleBox(index)) ? 'none' : 'block'}}>

                          <Row>
                            <Col sm={8} xs={12}>
                              <Field
                                  label={false}
                                  name={`${el}.title`}
                                  type="text"
                                  component={FieldTxt}
                                  placeholder={'Saisir un titre'}
                              />
                            </Col>
                            <Col sm={4} xs={12}>
                              <Field
                                  label={false}
                                  name={`${el}.template`}
                                  type="select"
                                  options={titleTemplateOptions}
                                  component={FieldSelect}
                              />
                            </Col>
                          </Row>

                        </CardBody>


                      </Card>
                      }

                      {fields.get(index).type == 'text' &&
                      <Card>
                        <CardHeader>
                          <i className="fa fa-align-justify"/> Bloc text {index}

                          <div className="card-actions">
                            <a href={`javascript:void(0)`} onClick={() => this.orderUp(fields, index)}><i className={'fa fa-arrow-up'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.orderDown(fields, index)}><i className={'fa fa-arrow-down'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.remove(fields, index)}><i className={'fa fa-trash'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.toggleBox(index)}><i className={this.checkToogleBox(index) ? 'fa fa-angle-up' : 'fa fa-angle-down'} /></a>
                            <a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'} /></a>
                          </div>

                        </CardHeader>

                        <CardBody style={{display : (this.checkToogleBox(index)) ? 'none' : 'block'}}>

                          <Field
                              label={false}
                              name={`${el}.template`}
                              type="select"
                              options={textTemplateOptions}
                              component={FieldSelect}
                          />

                          {this.state.loaded &&
                            <Field
                                label={false}
                                name={`${el}.text`}
                                type="text"
                                component={FieldCkEditor}
                            />
                          }

                        </CardBody>
                      </Card>
                      }

                      {fields.get(index).type == 'textImg' &&
                      <Card>
                        <CardHeader>
                          <i className="fa fa-align-justify"/><i className="fa fa-image"/> Text et image {index}

                          <div className="card-actions">
                            <a href={`javascript:void(0)`} onClick={() => this.orderUp(fields, index)}><i className={'fa fa-arrow-up'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.orderDown(fields, index)}><i className={'fa fa-arrow-down'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => fields.remove(index)}><i className={'fa fa-trash'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.toggleBox(index)}><i className={this.checkToogleBox(index) ? 'fa fa-angle-up' : 'fa fa-angle-down'} /></a>
                            <a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'} /></a>
                          </div>

                        </CardHeader>

                        <CardBody>

                          <Row>
                            <Col sm={7} xs={12}>
                              <Field
                                  label={false}
                                  name={`${el}.template`}
                                  type="select"
                                  options={textImgTemplateOptions}
                                  component={FieldSelect}
                              />
                              <Field
                                  label={false}
                                  name={`${el}.title`}
                                  type="text"
                                  component={FieldTxt}
                                  placeholder={'Saisir un titre'}
                              />
                              <Field
                                  label={false}
                                  name={`${el}.text`}
                                  type="textarea"
                                  component={FieldTxt}
                                  placeholder={'Description'}
                              />
                              <Field
                                  label={false}
                                  name={`${el}.url`}
                                  type="text"
                                  component={FieldTxt}
                                  placeholder={'Saisir une url'}
                              />

                            </Col>

                            <Col sm={5} xs={12}>

                              <input type="text" id={`mediaField${index}`} onChange={(event) => this.onImgChange(event, fields, index)} style={{position : 'absolute', left : '-90000px'}} />

                              {
                                fields.get(index).media &&
                                fields.get(index).media.url &&
                                fields.get(index).media.type == 'image' &&
                                <img src={`${ApiConfig.assetUrl}${fields.get(index).media.url}`} style={{maxWidth:'100%'}} />
                              }

                              <Button color={'success'} block onClick={() => this.openMediaBox(`mediaField${index}`)}>Media</Button>
                            </Col>

                          </Row>

                        </CardBody>

                      </Card>
                      }
                      {fields.get(index).type == 'img' &&
                      <Card>
                        <CardHeader>
                          <i className="fa fa-image"/> Image {index}

                          <div className="card-actions">
                            <a href={`javascript:void(0)`} onClick={() => this.orderUp(fields, index)}><i className={'fa fa-arrow-up'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.orderDown(fields, index)}><i className={'fa fa-arrow-down'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => fields.remove(index)}><i className={'fa fa-trash'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.toggleBox(index)}><i className={this.checkToogleBox(index) ? 'fa fa-angle-up' : 'fa fa-angle-down'} /></a>
                            <a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'} /></a>
                          </div>

                        </CardHeader>

                        <CardBody>

                          <input type="text" id={`mediaField${index}`} onChange={(event) => this.onImgChange(event, fields, index)} style={{position : 'absolute', left : '-90000px'}} />

                          {
                            fields.get(index).media &&
                            fields.get(index).media.url &&
                            fields.get(index).media.type == 'image' &&
                            <img src={`${ApiConfig.assetUrl}${fields.get(index).media.url}`} style={{maxWidth:'100%'}} />
                          }

                          <Button color={'success'} block onClick={() => this.openMediaBox(`mediaField${index}`)}>Media</Button>


                        </CardBody>

                      </Card>
                      }

                      {fields.get(index).type == 'collection' &&
                      <Card>
                        <CardHeader>
                          <i className="fa fa-th-large"/> Collection {index}

                          <div className="card-actions">
                            <a href={`javascript:void(0)`} onClick={() => this.orderUp(fields, index)}><i className={'fa fa-arrow-up'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.orderDown(fields, index)}><i className={'fa fa-arrow-down'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => fields.remove(index)}><i className={'fa fa-trash'} /></a>
                            <a href={`javascript:void(0)`} onClick={() => this.toggleBox(index)}><i className={this.checkToogleBox(index) ? 'fa fa-angle-up' : 'fa fa-angle-down'} /></a>
                            <a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'} /></a>
                          </div>

                        </CardHeader>

                        <CardBody>

                          <Row>
                            <Col sm={7} xs={12}>
                              <Field
                                  label={false}
                                  name={`${el}.template`}
                                  type="select"
                                  required={false}
                                  labelField={'name'}
                                  valueField={'value'}
                                  nullValue={'Choisir un template'}
                                  options={titleCollectionTemplateOptions}
                                  component={FieldSelect}
                              />
                              <Field
                                  label={false}
                                  name={`${el}.route`}
                                  type="text"
                                  component={FieldTxt}
                                  placeholder={'Route'}
                              />
                              <Field
                                  label={false}
                                  name={`${el}.title`}
                                  type="text"
                                  component={FieldTxt}
                                  placeholder={'Saisir un titre'}
                              />
                              <Field
                                  label={false}
                                  name={`${el}.text`}
                                  type="textarea"
                                  component={FieldTxt}
                                  placeholder={'Description'}
                              />

                            </Col>

                            <Col sm={5} xs={12}>

                              {fields.get(index).childrens && fields.get(index).childrens.map((el, index) => (

                                  <div key={index}>{index} {el.type}</div>

                              ))}

                              <Button color={'success'} block onClick={() => this.refs.popupCollection.handleOpen(index, fields.get(index))}>Edition du bloc</Button>

                            </Col>

                          </Row>


                        </CardBody>

                      </Card>
                      }

                    </div>

                )})}


                {defaultBlocOrder &&
                <Card>
                  <ButtonGroup>
                    <Button size="lg" onClick={() => fields.push({type : 'title'})} style={{flex : 1}}><i className={'fa fa-i-cursor'} /></Button>
                    <Button size="lg" onClick={() => fields.push({type : 'text'})} style={{flex : 1}}><i className={'fa fa-align-justify'} /></Button>
                    <Button size="lg" onClick={() => fields.push({type : 'img'})} style={{flex : 1}}><i className={'fa fa-image'} /></Button>
                    <Button size="lg" onClick={() => fields.push({type : 'textImg'})} style={{flex : 1}}><i className={'fa fa-align-justify'} /> + <i className={'fa fa-image'} /></Button>
                    <Button size="lg" onClick={() => fields.push({type : 'collection'})} style={{flex : 1}}><i className={'fa fa-th-large'} /></Button>
                  </ButtonGroup>
                </Card>
                }



              </div>

            </div>


        );

    }

};


export default FieldContents





// WEBPACK FOOTER //
// ./src/components/Form/wh-contents.js